// Firebase collection names - Keep in sync with mobile/config/constants.ts
export const COLLECTIONS = {
  USERS: 'users',
  MENU_ITEMS: 'menuItems',
  MENU_GROUPS: 'menuGroups',
  MENU_CATEGORIES: 'menuCategories',
  ORDERS: 'orders',
  DAILY_TICKET_COUNTERS: 'dailyTicketCounters',
  DISCOUNT_CODES: 'discountCodes',
  DISCOUNT_USAGE: 'discountUsage',
  CUSTOMER_TRUST_SCORES: 'customerTrustScores',
  REVIEWS: 'reviews',
  FAVORITES: 'favorites',
  CHATS: 'chats',
  DRIVER_LOCATIONS: 'driverLocations',
  DRIVER_LOCATION_HISTORY: 'driverLocationHistory',
  DELIVERY_FEE_ADJUSTMENTS: 'deliveryFeeAdjustments',
  RECENT_SEARCHES: 'recentSearches',
  PRINT_STATIONS: 'printStations',
  PRINT_ROUTING_RULES: 'printRoutingRules',
  PRINT_AGENTS: 'printAgents',
  PRINT_JOBS: 'printJobs',
  POS_SHIFTS: 'posShifts',
  POS_TRANSACTIONS: 'posTransactions',
  POS_PARKED_ORDERS: 'posParkedOrders',
  POS_CUSTOMERS: 'posCustomers',
  POS_CASH_MOVEMENTS: 'posCashMovements',
  POS_AUDIT_EVENTS: 'posAuditEvents',
  POS_DAILY_CLOSES: 'posDailyCloses',
  DRIVER_FLOAT_ACCOUNTS: 'driverFloatAccounts',
  DRIVER_FLOAT_LEDGER: 'driverFloatLedger',
  PHONE_ORDER_DRAFTS: 'phoneOrderDrafts',
  PHONE_ORDER_MESSAGES: 'phoneOrderMessages',
  PHONE_CALL_SESSIONS: 'phoneCallSessions',
  PHONE_CUSTOMER_PROFILES: 'phoneCustomerProfiles',
  PHONE_AGENTS: 'phoneAgents',
  LOCAL_AGENTS: 'localAgents',
  FINANCIAL_EVENTS: 'financialEvents',
  RESTAURANT_EXPENSES: 'restaurantExpenses',
  RESTAURANT_VENDORS: 'restaurantVendors',
  VENDOR_BILLS: 'vendorBills',
  VENDOR_PAYMENTS: 'vendorPayments',
  BANK_DEPOSITS: 'bankDeposits',
  ACCOUNTING_ATTACHMENTS: 'accountingAttachments',
  AI_FINANCE_REVIEWS: 'aiFinanceReviews',
  AI_REPORT_REQUESTS: 'aiReportRequests',
  AI_GENERATED_REPORTS: 'aiGeneratedReports',
  OPS_EVENTS: 'opsEvents',
  NOTIFICATION_DELIVERIES: 'notificationDeliveries',
  ORDER_COMMANDS: 'orderCommands',
} as const;

// Order status types
export const ORDER_STATUS = {
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
  ACCEPTED: 'accepted',
  PREPARING: 'preparing',
  READY_FOR_PICKUP: 'ready_for_pickup',
  ASSIGNED: 'assigned',
  OUT_FOR_DELIVERY: 'out_for_delivery',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
  REJECTED: 'rejected',
} as const;

// User roles
export const USER_ROLES = {
  CUSTOMER: 'customer',
  ADMIN: 'admin',
  DRIVER: 'driver',
  CALL_CENTER: 'call_center',
  PRINT_AGENT: 'print_agent',
  PHONE_AGENT: 'phone_agent',
  LOCAL_AGENT: 'local_agent',
} as const;

// Delivery types
export const DELIVERY_TYPES = {
  PICKUP: 'pickup',
  DELIVERY: 'delivery',
} as const;
